import { Component } from "react";
import BusquedaPersona from "../../../componentes/Autorizaciones/IngresoAutorizacion/BusquedaPersona";
import Layout from "../../../componentes/Comunes/Layout/Layout";

export default class IncluirAutorizacion extends Component {
  render() {
    return (
      <Layout>
        <div>
          <BusquedaPersona />
        </div>
      </Layout>
    );
  }
}
